import  {baseActions}  from "./base.actions";

export const certformActions = {
    edit
};

function edit(obj,id,func=null) {
    return baseActions.edit(obj,'certificationform',id,null,func);
}
